import { Grid, Box, Typography, Tooltip } from '@mui/material';
import { AiFillEdit } from 'react-icons/ai';
import { NOT_AVAILABLE } from '../pages/Global/Constants';
import { StyledIconButton } from '../utils/StyleTable';

export default function ViewCardComponent({ title = 'Details', fields = [], handleEdit }) {
  return (
    <Grid item xs={12} sm={6} md={12} mb={3}>
      <Typography variant="body1" className="headingLineUp headingLineUpOut">
        {title}
      </Typography>
      <Box className="viewLeadCard cardTopMinusMargin" sx={{ height: 'calc(100% - 16px)' }}>
        {handleEdit && (
          <Box className="extraTopIcon">
            <Tooltip
              title="Edit"
              placement="top"
              arrow
              onClick={(e) => {
                if (handleEdit) handleEdit(e, fields);
                // handleEditLoanRequirementDialog(e);
              }}
            >
              <StyledIconButton className="squareIconButton squareIconButtonFilled">
                <AiFillEdit size={14} />
              </StyledIconButton>
            </Tooltip>
          </Box>
        )}
        <Grid container spacing={3}>
          {fields.map((field, index) => (
            <Grid item xs={4} key={index}>
              <Box className="displayFlex">
                {field?.icon}
                <Box ml={1}>
                  <Typography variant="body2" className="labelText">
                    {field?.label}
                  </Typography>
                  <Typography variant="subtitle2" className="labelValue">
                    {field?.value || NOT_AVAILABLE}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Grid>
  );
}
